<h3>Review Notes</h3>
@if (reviewNotes?.length > 0) {
  <section>
    @for (reviewNote of reviewNotes; track reviewNote) {
      <div class="padding-all margin-top margin-bottom">
        <div #replyForm>
          @if (canViewNote(reviewNote)) {
            <div class="note-group padding-all" [ngClass]="{ 'private-note': reviewNote.type < 2, 'public-note': reviewNote.type == 2 }">
              @if (displayExpander(reviewNote.notes)) {
                <div class="float-left">
                  @if (!replyForm.opened) {
                    <button (click)="toggleReply(replyForm)"><svg-icon icon="icon-caret-right" class="small gray"></svg-icon></button>
                  }
                  @if (replyForm.opened) {
                    <button (click)="toggleReply(replyForm)"><svg-icon icon="icon-caret-down" class="small gray"></svg-icon></button>
                  }
                </div>
              }
              <div class="notes">
                <div class="note-header default-font"><strong>{{reviewNote.createdBy}}</strong><span class="float-right">{{reviewNote.createdDate | date: 'M/d/yy | h:mma'}}</span></div>
                <div [innerHTML]="reviewNote.text"></div>
                @if (isArray(reviewNote.files)) {
                  <hr />
                }
                <div class="childNotes" [ngClass]="{ 'opened': replyForm.opened }">
                  @for (childNote of reviewNote.notes; track childNote) {
                    <div>
                      <div class="note-header default-font">
                        <strong>{{childNote.createdBy}}</strong><span class="float-right">{{ childNote.createdDate | date: 'M/d/yy | h:mma' }}</span>
                      </div>
                      <div [innerHTML]="childNote.text"></div>
                    </div>
                  }
                </div>
              </div>
              @if (!replyForm.isReplying) {
                <div class="text-align-right">
                  <button (click)="openReplyForm(replyForm)">
                    <svg-icon class="cursor-pointer" icon="icon-reply"></svg-icon>
                  </button>
                </div>
              }
            </div>
          }
          @if (replyForm.isReplying) {
            <div>
              <div class="margin-top" [(froalaModel)]="replyForm.replyText" [froalaEditor]="replyFroalaOptions"></div>
              @if (replyForm.isDirty && !replyForm.replyText) {
                <div class="notes error">
                  <small class="error">Reply text is required</small>
                </div>
              }
              <div class="text-align-center minor-margin-top">
                <span class="minor-margin-right">
                  <button class="button hollow white-background" (click)="resetReplyForm(replyForm)">Cancel</button>
                </span>
                <span class="minor-margin-left">
                  <button class="button" (click)="reply(reviewNote, replyForm)">Add Note</button>
                </span>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </section>
} @else {
  <p>There currently are no review notes.</p>
}

